/**************************************************
 * Nombre:       Tarjeta_Documento_Inicio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {TIPODOCSREQ} from "../../Constantes";
import {CheckCircle, InsertPhoto, PictureAsPdf} from '@mui/icons-material'
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Cargar_Imagen from "../Dialogos/Dialogo_Cargar_Imagen";
import {useContext, useEffect, useState} from "react";
import {usuarioContext} from "../../App";
import {irUrl} from "../../Utilidades/irUrl";
import Dialogo_Cargar_Pdf from "../Dialogos/Dialogo_Cargar_Pdf";
import {theme} from "../../Tema";


const Tarjeta_Documento_Inicio = ({item}) => {
    const cData = useContext(usuarioContext)
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Cargar_Imagen, titulo: 'Carga de imagen'})
    const {Dialogo: DialogoPdf, abrir: abrirPdf} = useDialogo({Componente: Dialogo_Cargar_Pdf, titulo: 'Carga de Pdf'})
    const [esSubido, setEsSubido] = useState(false)
    const [documento, setDocumento] = useState({})


    const obtenerTipo = (tipo) => {

        switch (tipo) {
            case TIPODOCSREQ[0]: { //Pdf
                return <PictureAsPdf sx={{fill: '#ffffff90', height: 80, width: 80}}/>
                break
            }
            case TIPODOCSREQ[1]: { //Imagen
                return <InsertPhoto sx={{fill: '#ffffff90', height: 80, width: 80}}/>
                break
            }
        }

    }

    useEffect(() => {

        if (cData.usuario.documentos && cData.usuario.documentos.length > 0) {

            let docs = cData.usuario.documentos;
            let index = docs.findIndex((e) => e.nombre === item.nombre);
            if (index > -1) {
                setEsSubido(true)
                setDocumento(docs[index])
            }

        }

    }, [cData.usuario])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
        >

            <Dialogo/>

            <DialogoPdf/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Typography sx={{
                    fontSize: 12,
                    fontWeight: 600,
                    textAlign: 'center',
                    lineHeight: 1.1,
                    textOverflow: "ellipsis",
                    display: '-webkit-box',
                    overflow: 'hidden',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    height: 28
                }}>
                    {item.nombre}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                {esSubido ? <CheckCircle
                    onClick={() => irUrl(documento.recurso)}
                    sx={{fill: '#fff', height: 50, width: 50, cursor: 'pointer'}}/> : obtenerTipo(item.tipo)}
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Button
                    color={'action'}
                    onClick={() => item.tipo === 'Pdf' ? abrirPdf(item) : abrir(item)}
                    variant={esSubido ? 'outlined' : 'contained'}
                    fullWidth sx={{
                    fontSize: 12,
                    px: 1,
                    pt: 0.4,
                    pb: 0.5,
                    color: esSubido ? '#fff' : theme.palette.primary.main
                }}>{esSubido ? 'Cambiar' : 'Subir'}</Button>
            </Grid>

            {esSubido &&
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -1}}>
                    <Button
                        color={'action'}
                        onClick={() => irUrl(documento.recurso)}
                        variant={'text'}
                        fullWidth sx={{
                        fontSize: 12,
                        px: 1,
                        pt: 0.4,
                        pb: 0.5,
                        color: '#fff'
                    }}>{'Ver'}</Button>
                </Grid>
            }


        </Grid>
    )

}
export default Tarjeta_Documento_Inicio